export default __webpack_public_path__ + "static/media/854.b9a9d382.png";